<template>
  <ion-page>
    <main-header></main-header>
    <ion-content padding>
      <ion-list>
        <ion-item>
          <ion-label>Dark Mode</ion-label>
          <ion-toggle
            slot="start"
            name="darkmode"
            @ionChange="applyDarkMode($event.detail.checked)"
            :checked="darkModeEnabled"
          ></ion-toggle>
        </ion-item>
      </ion-list>
      <hr />
      <ion-list>
        <ion-list-header>Details</ion-list-header>
        <ion-item>
          <ion-label>User Agent</ion-label>
          <ion-badge slot="end">{{ userAgent }}</ion-badge>
        </ion-item>
        <ion-item>
          <ion-label>Package Version</ion-label>
          <ion-badge slot="end">{{ packageVersion }}</ion-badge>
        </ion-item>
      </ion-list>
      <hr />
      <ion-list>
        <ion-list-header>State</ion-list-header>
        <ion-item>
          <ion-label>User</ion-label>
          <div slot="end" class="wide">
            <pre>{{ user }}</pre>
          </div>
        </ion-item>
        <ion-item>
          <ion-label>Claims</ion-label>
          <div slot="end" class="wide">
            <pre>{{ userClaims }}</pre>
          </div>
        </ion-item>
      </ion-list>
    </ion-content>
  </ion-page>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { version } from "@/../package.json";

export default {
  title: "Labs",

  methods: {
    ...mapActions({
      applyDarkMode: "setDarkMode"
    })
  },

  computed: {
    ...mapGetters({
      darkModeEnabled: "darkMode"
    }),
    ...mapGetters("auth", ["user"]),
    ...mapState("auth", ["userClaims"]),

    userAgent() {
      return navigator.userAgent;
    },

    packageVersion() {
      return version;
    }
  }
};
</script>

<style lang="scss">
.wide {
  max-width: 75%;
  overflow-x: auto;
}
pre {
  background-color: #cccccc;
}
</style>
